module.exports = __webpack_public_path__ + "img/knue_gallery8.8d924192.jpg";